import { __assign, __rest, __spreadArray } from "tslib";
import React, { useRef } from "react";
import { View, Image, StyleSheet, Text } from "react-native";
import { colors, PnmacSectionListView, PnmacRowHeader, PnmacRowItem, PnmacToolTip, PnmacImage, PnmacHtmlToNative } from "pnmac-universal-components";
import moment from "moment";
import styles from "../../styles/styles";
import { currencyFormatterWithoutSign, amountNullCheck } from '../../utils.js';
import { textStyle } from '../../v2/theme';
var InsuranceItemTypeCode = {
  EAPHomeowners: 1044,
  EAPFlood: 1045,
  EAPWind: 1046,
  EAPOther: 1047,
  EAPFloodGap: 1048
};
var TaxesItemTypeCode = {
  EAPCombinedTax: 1020,
  EAPCountyTax: 1021,
  EAPCityTax: 1022,
  EAPSchoolTax: 1023,
  EAPVillageTax: 1024,
  EAPMiscAssessmentTax: 1025,
  EAPGroundRentUtiltyTax: 1026,
  EAPMiscTax: 1027,
  EAPSupplementalAdditionalTax: 1028,
  EAPFeesPenaltyTax: 1029
};
var EscrowAnalysisDetails = function (_a) {
  var _b, _c;
  var matches = _a.matches,
    translations = _a.translations,
    props = __rest(_a, ["matches", "translations"]);
  var DATAEXPANDABLE = [];
  var lookBackDataLatest = props.layout.escrowAnalysisLookBackData.length > 0 ? props.layout.escrowAnalysisLookBackData[0] : [];
  var lookBackDataPrevious = props.layout.escrowAnalysisLookBackData.length > 0 ? props.layout.escrowAnalysisLookBackData[1] : [];
  var escrow = (_c = (_b = props.layout) === null || _b === void 0 ? void 0 : _b.currentLoanActivity) === null || _c === void 0 ? void 0 : _c.eescrow;
  var insurancesLatest = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.insuranceLineItems) || []; //Hazard Insurance
  var insurancesPrevious = (lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.insuranceLineItems) || []; //Hazard Insurance
  var taxesLatest = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.taxLineItems) || [];
  var taxesPrevious = (lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.taxLineItems) || [];
  var mortgagesLatest = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.miLineItems) || [];
  var mortgagesPrevious = (lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.miLineItems) || [];
  var isPaymentSupplementVisible = (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.paymentSupplementAmount) != 0;
  if (insurancesLatest && insurancesLatest.length > 0) {
    insurancesLatest.map(function (s) {
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance);
      });
      if (!ta) {
        DATAEXPANDABLE.push({
          title: translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance,
          previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.insuranceLineItemsTotal),
          escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.insuranceLineItemsTotal) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.insuranceLineItemsTotal) : "N/A",
          toolTip: '',
          data: []
        });
        ta = DATAEXPANDABLE.find(function (d) {
          return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance);
        });
      }
      if (s.itemTypeCode == InsuranceItemTypeCode.EAPHomeowners) {
        var homeOwnerItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPHomeowners_1044);
        });
        if (!homeOwnerItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPHomeowners_1044,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == InsuranceItemTypeCode.EAPFlood) {
        var floodItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPFlood_1045);
        });
        if (!floodItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPFlood_1045,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == InsuranceItemTypeCode.EAPWind) {
        var windItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPWind_1046);
        });
        if (!windItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPWind_1046,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance,
            previousEscrowAmount: "N/A",
            escrowAmount: (s === null || s === void 0 ? void 0 : s.monthlyAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == InsuranceItemTypeCode.EAPOther) {
        var otherItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPOther_1047);
        });
        if (!otherItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPOther_1047,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance,
            previousEscrowAmount: "N/A",
            escrowAmount: (s === null || s === void 0 ? void 0 : s.monthlyAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == InsuranceItemTypeCode.EAPFloodGap) {
        var floodGapItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPFloodGap_1048);
        });
        if (!floodGapItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPFloodGap_1048,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
    });
    var localInsuranceIndex_1 = 0;
    insurancesPrevious.map(function (s) {
      var _a;
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalHomeownersInsurance);
      });
      if (s.itemTypeCode == InsuranceItemTypeCode.EAPHomeowners || s.itemTypeCode == InsuranceItemTypeCode.EAPWind || s.itemTypeCode == InsuranceItemTypeCode.EAPFlood || s.itemTypeCode == InsuranceItemTypeCode.EAPOther || s.itemTypeCode == InsuranceItemTypeCode.EAPFloodGap) {
        var updatedArray = __spreadArray([], ta.data, true);
        if ((_a = updatedArray[localInsuranceIndex_1]) === null || _a === void 0 ? void 0 : _a.previousEscrowAmount) {
          updatedArray[localInsuranceIndex_1].previousEscrowAmount = amountNullCheck(s.monthlyAmount);
          localInsuranceIndex_1 = localInsuranceIndex_1 + 1;
        }
      }
    });
  }
  if (taxesLatest && taxesLatest.length > 0) {
    taxesLatest.map(function (s) {
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes);
      });
      if (!ta) {
        DATAEXPANDABLE.push({
          title: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
          previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.taxLineItemsTotalAmount),
          escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.taxLineItemsTotalAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.taxLineItemsTotalAmount) : "N/A",
          toolTip: '',
          data: []
        });
        ta = DATAEXPANDABLE.find(function (d) {
          return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes);
        });
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPCombinedTax) {
        var combinedTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPCombinedTax_1020);
        });
        if (!combinedTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPCombinedTax_1020,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPCountyTax) {
        var countyTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPCountyTax_1021);
        });
        if (!countyTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPCountyTax_1021,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: (s === null || s === void 0 ? void 0 : s.monthlyAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPCityTax) {
        var cityTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPCityTax_1022);
        });
        if (!cityTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPCityTax_1022,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPSchoolTax) {
        var schoolTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPSchoolTax_1023);
        });
        if (!schoolTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPSchoolTax_1023,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPVillageTax) {
        var villageTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPVillageTax_1024);
        });
        if (!villageTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPVillageTax_1024,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPMiscAssessmentTax) {
        var miscTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPMiscTax_1025);
        });
        if (!miscTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPMiscTax_1025,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPGroundRentUtiltyTax) {
        var groundRentTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPGroundRentUtiltyTax_1026);
        });
        if (!groundRentTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPGroundRentUtiltyTax_1026,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPMiscTax) {
        var miscTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPMiscTax_1027);
        });
        if (!miscTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPMiscTax_1027,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPSupplementalAdditionalTax) {
        var supplementalTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPSupplementalAdditionalTax_1028);
        });
        if (!supplementalTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPSupplementalAdditionalTax_1028,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
      if (s.itemTypeCode == TaxesItemTypeCode.EAPFeesPenaltyTax) {
        var feesPenaltyTaxItem = ta.data.find(function (d) {
          return d.label == (translations === null || translations === void 0 ? void 0 : translations.EAPFeesPenaltyTax_1029);
        });
        if (!feesPenaltyTaxItem) {
          ta.data.push({
            label: translations === null || translations === void 0 ? void 0 : translations.EAPFeesPenaltyTax_1029,
            header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes,
            previousEscrowAmount: "N/A",
            escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
          });
        }
      }
    });
    var localTaxIndex_1 = 0;
    taxesPrevious.map(function (s) {
      var _a;
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalTaxes);
      });
      if (s.itemTypeCode == TaxesItemTypeCode.EAPCombinedTax || s.itemTypeCode == TaxesItemTypeCode.EAPCountyTax || s.itemTypeCode == TaxesItemTypeCode.EAPCityTax || s.itemTypeCode == TaxesItemTypeCode.EAPSchoolTax || s.itemTypeCode == TaxesItemTypeCode.EAPVillageTax || s.itemTypeCode == TaxesItemTypeCode.EAPMiscAssessmentTax || s.itemTypeCode == TaxesItemTypeCode.EAPGroundRentUtiltyTax || s.itemTypeCode == TaxesItemTypeCode.EAPMiscTax || s.itemTypeCode == TaxesItemTypeCode.EAPSupplementalAdditionalTax || s.itemTypeCode == TaxesItemTypeCode.EAPFeesPenaltyTax) {
        var updatedArray = __spreadArray([], ta.data, true);
        if ((_a = updatedArray[localTaxIndex_1]) === null || _a === void 0 ? void 0 : _a.previousEscrowAmount) {
          updatedArray[localTaxIndex_1].previousEscrowAmount = amountNullCheck(s.monthlyAmount);
          localTaxIndex_1 = localTaxIndex_1 + 1;
        }
      }
    });
  }
  if (mortgagesLatest && mortgagesLatest.length > 0) {
    mortgagesLatest.map(function (s) {
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalMortgageInsurance);
      });
      if (!ta) {
        DATAEXPANDABLE.push({
          title: translations === null || translations === void 0 ? void 0 : translations.EAPTotalMortgageInsurance,
          previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.miLineItemsTotalAmount),
          escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.miLineItemsTotalAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.miLineItemsTotalAmount) : "N/A",
          toolTip: '',
          data: []
        });
        ta = DATAEXPANDABLE.find(function (d) {
          return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalMortgageInsurance);
        });
      }
      ta.data.push({
        label: translations === null || translations === void 0 ? void 0 : translations.EAPMortgageInsurance,
        header: translations === null || translations === void 0 ? void 0 : translations.EAPTotalMortgageInsurance,
        previousEscrowAmount: "N/A",
        escrowAmount: s.monthlyAmount ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', s.monthlyAmount) : "N/A"
      });
    });
    mortgagesPrevious.map(function (s, index) {
      var ta = DATAEXPANDABLE.find(function (d) {
        return d.title == (translations === null || translations === void 0 ? void 0 : translations.EAPTotalMortgageInsurance);
      });
      var updatedArray = __spreadArray([], ta.data, true);
      updatedArray[index].previousEscrowAmount = amountNullCheck(s.monthlyAmount);
    });
  }
  var totalReserveAmountData = {
    title: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPTotalReserveAmount),
    previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.totalReserveAmount),
    escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalReserveAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalReserveAmount) : "N/A",
    toolTip: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPHelp1Html),
    data: [{
      label: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPReserveAmount),
      header: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPTotalReserveAmount),
      previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.totalReserveAmount),
      escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalReserveAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalReserveAmount) : "N/A"
    }, {
      label: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPReservePercentage),
      header: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPTotalReserveAmount),
      previousEscrowAmount: (lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.reservePercentage) ? "".concat(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.reservePercentage, "%") : "N/A",
      escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.reservePercentage) ? "".concat(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.reservePercentage, "%") : "N/A"
    }]
  };
  var totalShortageAmountData = {
    title: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPTotalShortageAmount),
    previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.totalShortageAmount),
    escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalShortageAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalShortageAmount) : "N/A",
    toolTip: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPHelp2Html),
    data: [{
      label: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPShortageAmount),
      header: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPTotalShortageAmount),
      previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.totalShortageAmount),
      escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalShortageAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.totalShortageAmount) : "N/A"
    }]
  };
  DATAEXPANDABLE.push(totalReserveAmountData, totalShortageAmountData);
  if ((lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.hudAssistanceBuyDownAmount) != 0 || (lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.hudAssistanceBuyDownAmount) != 0) {
    var totalBuyDownAmountData = {
      title: "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPUDAssistanceBuyDownAmount),
      previousEscrowAmount: amountNullCheck(lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.hudAssistanceBuyDownAmount),
      escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.hudAssistanceBuyDownAmount) ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.hudAssistanceBuyDownAmount) : "N/A",
      data: []
    };
    DATAEXPANDABLE.push(totalBuyDownAmountData);
  }
  if (isPaymentSupplementVisible) {
    var paymentSupplementtData = {
      title: "".concat(translations === null || translations === void 0 ? void 0 : translations.PSMonthlyReduction),
      previousEscrowAmount: (lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.paymentSupplementAmount) != 0 ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataPrevious === null || lookBackDataPrevious === void 0 ? void 0 : lookBackDataPrevious.paymentSupplementAmount) : "N/A",
      escrowAmount: (lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.paymentSupplementAmount) != 0 ? currencyFormatterWithoutSign('en-US', 'currency', 'USD', lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.paymentSupplementAmount) : "N/A",
      data: []
    };
    DATAEXPANDABLE.push(paymentSupplementtData);
  }
  //Add sub header
  var headerTable = {
    title: "".concat(translations.EAPCurrentEscrowDetails),
    previousEscrowAmount: "".concat(translations.EAPPrevious),
    escrowAmount: "".concat(translations.EAPNew),
    data: []
  };
  DATAEXPANDABLE.unshift(headerTable);
  //Add main title
  var TitleTable = {
    title: "".concat(translations.EAPDetailsHeader).concat(moment(lookBackDataLatest === null || lookBackDataLatest === void 0 ? void 0 : lookBackDataLatest.analysisEffectiveDate).format("MMMM D, YYYY")),
    previousEscrowAmount: null,
    escrowAmount: null,
    data: []
  };
  DATAEXPANDABLE.unshift(TitleTable);
  var titleStyle = {
    fontSize: matches.small ? 14 : 16
  };
  var RenderItemTitleView = function (_a) {
    var title = _a.title,
      flex = _a.flex,
      _b = _a.isTableHeader,
      isTableHeader = _b === void 0 ? false : _b,
      _c = _a.isTableTitle,
      isTableTitle = _c === void 0 ? false : _c;
    if (isTableTitle) {
      return /*#__PURE__*/React.createElement(Text, {
        style: [textStyle.formTitleSection, {
          flex: flex
        }]
      }, title);
    } else {
      return /*#__PURE__*/React.createElement(Text, {
        style: [textStyle.formBody, titleStyle, {
          flex: flex
        }]
      }, title);
    }
  };
  var lastItemTitle = DATAEXPANDABLE[DATAEXPANDABLE.length - 1].title;
  var expRef = useRef(null);
  React.useEffect(function () {
    var _a;
    if ((expRef === null || expRef === void 0 ? void 0 : expRef.current) != null) {
      (_a = expRef === null || expRef === void 0 ? void 0 : expRef.current) === null || _a === void 0 ? void 0 : _a.collapseItem(translations === null || translations === void 0 ? void 0 : translations.EAPTotalReserveAmount);
    }
  }, [expRef]);
  return /*#__PURE__*/React.createElement(View, {
    style: {
      borderRadius: 10,
      marginTop: 10,
      overflow: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(PnmacSectionListView, {
    openDefaults: [translations.PastPaymentsBreakdown],
    idTag1: 'escrowAnalysisDetails',
    ref: expRef,
    data: DATAEXPANDABLE,
    collapsableSections: true,
    renderItem: function (_a, collapsed) {
      var _b, _c;
      var index = _a.index,
        item = _a.item;
      if (collapsed.some(function (s) {
        return s == item.header;
      })) {
        var notLastSection_1 = item.header != lastItemTitle;
        var notLastElement_1 = index <= ((_c = (_b = DATAEXPANDABLE.find(function (title) {
          return title.title == item.header;
        })) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.length) - 2;
        return /*#__PURE__*/React.createElement(PnmacRowItem, {
          renderChildren: function () {
            var _a;
            return /*#__PURE__*/React.createElement(View, {
              style: __assign(__assign({}, (_a = styles.selectionListView) === null || _a === void 0 ? void 0 : _a.rowItemStyles), {
                borderBottomRightRadius: notLastElement_1 || notLastSection_1 ? 0 : 10,
                borderBottomLeftRadius: notLastElement_1 || notLastSection_1 ? 0 : 10,
                overflow: notLastElement_1 ? 'visible' : 'hidden'
              })
            }, /*#__PURE__*/React.createElement(Text, {
              style: [textStyle.formBody, {
                flex: 2.2
              }]
            }, item.label), /*#__PURE__*/React.createElement(Text, {
              style: [textStyle.formBody, {
                flex: 1.0
              }]
            }, item.previousEscrowAmount), /*#__PURE__*/React.createElement(Text, {
              style: [textStyle.formBody, {
                flex: 1.0
              }]
            }, item.escrowAmount), /*#__PURE__*/React.createElement(View, {
              style: {
                flex: 0.4
              }
            }));
          }
        });
      } else {
        return null;
      }
    },
    renderSectionHeader: function (_a) {
      var _b;
      var _c = _a.section,
        title = _c.title,
        previousEscrowAmount = _c.previousEscrowAmount,
        escrowAmount = _c.escrowAmount,
        toolTip = _c.toolTip,
        amountChanged = _c.amountChanged;
      var isTableHeader = title == "".concat(translations.EAPCurrentEscrowDetails);
      var isTableTitle = previousEscrowAmount == null;
      var isPaymentSupplementRow = title == "".concat(translations === null || translations === void 0 ? void 0 : translations.PSMonthlyReduction);
      var isBuyDownCreditRow = title == "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPUDAssistanceBuyDownAmount);
      var isTotalReserveAmountSection = title == "".concat(translations === null || translations === void 0 ? void 0 : translations.EAPTotalReserveAmount);
      var isExpand = ((_b = expRef === null || expRef === void 0 ? void 0 : expRef.current) === null || _b === void 0 ? void 0 : _b.state.collapsed.indexOf(title)) > -1 && !isTableTitle && !isBuyDownCreditRow && isTotalReserveAmountSection && !isPaymentSupplementRow;
      var isLastElement = title == "".concat(lastItemTitle);
      return /*#__PURE__*/React.createElement(PnmacRowHeader
      //rowHeaderStyles={styles.selectionListView.rowHeaderStyles}
      , {
        //rowHeaderStyles={styles.selectionListView.rowHeaderStyles}
        rowHeaderContainerStyles: {
          borderBottomColor: "#EFEFEF",
          borderBottomWidth: 1,
          borderRadius: 0,
          borderBottomLeftRadius: isLastElement ? isExpand ? 0 : 10 : 0,
          borderBottomRightRadius: isLastElement ? isExpand ? 0 : 10 : 0,
          marginBottom: 0,
          marginTop: 0,
          elevation: 0,
          shadowOffset: {
            width: 0,
            height: 0
          },
          shadowOpacity: 0,
          shadowRadius: 0,
          overflow: 'hidden',
          marginVertical: -20
        },
        onClickExpand: function () {
          var _a;
          return isTableHeader || isTableTitle || isBuyDownCreditRow || isPaymentSupplementRow ? null : (_a = expRef === null || expRef === void 0 ? void 0 : expRef.current) === null || _a === void 0 ? void 0 : _a.collapseItem(title);
        },
        renderChildren: function () {
          return /*#__PURE__*/React.createElement(View, {
            style: {
              flexDirection: 'column',
              justifyContent: 'center'
            }
          }, /*#__PURE__*/React.createElement(View, {
            id: title,
            style: {
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              paddingTop: 10
            }
          }, /*#__PURE__*/React.createElement(RenderItemTitleView, {
            flex: 2.2,
            isTableHeader: isTableHeader,
            isTableTitle: isTableTitle,
            title: title
          }), isTableTitle ? null : /*#__PURE__*/React.createElement(RenderItemTitleView, {
            flex: 1,
            isTableHeader: isTableHeader,
            isTableTitle: isTableTitle,
            title: previousEscrowAmount
          }), isTableTitle ? null : /*#__PURE__*/React.createElement(RenderItemTitleView, {
            flex: 1,
            isTableHeader: isTableHeader,
            isTableTitle: isTableTitle,
            title: escrowAmount
          }), isTableHeader || isTableTitle || isBuyDownCreditRow || isPaymentSupplementRow ? /*#__PURE__*/React.createElement(View, {
            style: {
              flex: 0.4
            }
          }) : /*#__PURE__*/React.createElement(View, {
            style: {
              flex: 0.4
            }
          }, /*#__PURE__*/React.createElement(Image, {
            alt: isExpand ? "Click to expand section" : "Click to collapse section",
            style: isExpand ? {
              transform: [{
                rotate: '180deg'
              }],
              width: 10,
              height: 6,
              marginStart: 6,
              marginEnd: 10
            } : {
              width: 10,
              height: 6,
              marginStart: 6,
              marginEnd: 10
            },
            source: require("../../assets/downarrowBlue.png")
          }))), isExpand ? /*#__PURE__*/React.createElement(View, {
            style: {
              paddingTop: 10,
              paddingBottom: 10
            }
          }, toolTip ? /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
            value: toolTip
          }) : null) : null);
        }
      });
    }
  }));
};
export default EscrowAnalysisDetails;
var eaStyles = StyleSheet.create({
  itemTitleStyle: {
    color: colors.black,
    fontWeight: '700'
  },
  itemHeadingStyle: {
    fontSize: 14,
    color: colors.black,
    fontWeight: '600'
  }
});